import React from 'react';

import { SecondCopyModal } from 'pages/shared/components';

export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export type EmailModalProps = {
  open: boolean;
  email: string;
  boletoCount: number;
  totalAmount: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onEmailChange: (value: string) => void;
  description?: React.ReactNode;
};

const EmailModal = ({
  open,
  email,
  boletoCount,
  totalAmount,
  loading = false,
  onClose,
  onSubmit,
  onEmailChange,
  description,
}: EmailModalProps): JSX.Element => {
  const boletoLabel = boletoCount === 1 ? 'boleto' : 'boletos';
  const defaultDescription = (
    <>
      Será enviada a 2ª via de <strong>{boletoCount} {boletoLabel}</strong>{' '}
      para o e-mail informado.
    </>
  );

  return (
    <SecondCopyModal
      open={open}
      mode="email"
      email={email}
      itemCount={boletoCount}
      totalAmount={totalAmount}
      showFormatSelection={false}
      loading={loading}
      submitDisabled={!isValidEmail(email)}
      onClose={onClose}
      onSubmit={onSubmit}
      onEmailChange={onEmailChange}
      itemLabelSingular="boleto"
      itemLabelPlural="boletos"
      description={description ?? defaultDescription}
    />
  );
};

export default EmailModal;
